import type { RussiaRequestListQuery } from '@magimp/shared';

// Internal helper shared by the russia-requests client modules. Mirror
// of `apps/web/src/api/requests/_query.ts`. Kept separate from the
// China-side helper to avoid cross-imports between the two clients.
export function withQuery(path: string, qs: string): string {
  return qs.length > 0 ? `${path}?${qs}` : path;
}

/**
 * @aiPurpose serialize the russia-requests list filters into a URL query
 *   string. Surface mirrors `RussiaRequestListQuerySchema` —
 *   `status`, `type`, `managerId`, `q`, `cursor`, `limit`. SLA filters
 *   land alongside the later UI slice (epic #935) when those columns
 *   ship.
 */
export function serializeRussiaRequestFilters(
  filters: Partial<RussiaRequestListQuery> = {},
): string {
  const sp = new URLSearchParams();
  if (filters.status) sp.set('status', filters.status);
  if (filters.type) sp.set('type', filters.type);
  if (filters.managerId) sp.set('managerId', filters.managerId);
  if (filters.q) sp.set('q', filters.q);
  if (filters.cursor) sp.set('cursor', filters.cursor);
  if (filters.limit !== undefined) sp.set('limit', String(filters.limit));
  return sp.toString();
}
